// extracted by mini-css-extract-plugin
export default {"progressBar":"EntityTask_progressBar__jBLz0","listItem":"EntityTask_listItem__h8Ava","lineThrough":"EntityTask_lineThrough__nIjCV","detail":"EntityTask_detail__0Aysx"};